(() => {
  const selector = "[data-gbof-dough-chooser]";

  function initialise(chooser) {
    const questions = [...chooser.querySelectorAll("[data-gbof-chooser-question]")];
    const progress = chooser.querySelector("[data-gbof-chooser-progress]");
    const progressText = chooser.querySelector("[data-gbof-chooser-progress-text]");
    const result = chooser.querySelector("[data-gbof-chooser-result]");
    const title = chooser.querySelector("[data-gbof-chooser-result-title]");
    const copy = chooser.querySelector("[data-gbof-chooser-result-copy]");
    const link = chooser.querySelector("[data-gbof-chooser-result-link]");
    const restart = chooser.querySelector("[data-gbof-chooser-restart]");
    if (questions.length !== 2 || !progress || !progressText || !result || !title || !copy || !link || !restart) return;
    const getStickyCta = () => chooser.closest(".gbof-dough-landing")?.querySelector(".gbof-dough-landing__sticky-cta");

    const matches = {
      easy: {
        title: "Easy Stretch",
        copy: "A forgiving place to start: easy to press, easy to stretch and built for relaxed home pizza nights.",
        href: chooser.dataset.easyStretchUrl,
        cta: "Shop Easy Stretch",
      },
      romana: {
        title: "Romana Tonda",
        copy: "Light, thin and crisp. Brilliant for complete novices — and anyone who loves a delicate base.",
        href: chooser.dataset.romanaUrl,
        cta: "Shop Romana Tonda",
      },
      original: {
        title: "Original Neapolitan",
        copy: "The classic pizza-night all-rounder: a crisp base, puffy crust and dependable Neapolitan character.",
        href: chooser.dataset.originalUrl,
        cta: "Shop Original Neapolitan",
      },
      sourdough: {
        title: "All Natural Sourdough",
        copy: "Wild yeast and deeper flavour for when you fancy a tangier crust and have time for a slower proof.",
        href: chooser.dataset.sourdoughUrl,
        cta: "Shop Sourdough",
      },
    };

    let preference = "";
    let experience = "";

    const setProgress = (step) => {
      progress.value = step;
      progress.setAttribute("aria-valuenow", String(step));
      progressText.textContent = `${step} of 2`;
    };

    const setSelected = (group, selected) => {
      group.querySelectorAll("[data-gbof-choice]").forEach((button) => {
        const active = button === selected;
        button.setAttribute("aria-pressed", String(active));
        button.classList.toggle("is-selected", active);
      });
    };

    const showQuestion = (index) => {
      questions.forEach((question, questionIndex) => { question.hidden = questionIndex !== index; });
      result.hidden = true;
      const stickyCta = getStickyCta();
      stickyCta?.classList.remove("is-suppressed");
      stickyCta?.setAttribute("aria-hidden", "false");
      setProgress(index + 1);
    };

    const renderResult = () => {
      let matchKey = preference;
      if (preference === "original" && experience === "new") matchKey = "easy";
      const match = matches[matchKey];
      if (!match?.href) return;
      title.textContent = match.title;
      copy.textContent = match.copy;
      link.href = match.href;
      link.textContent = match.cta;
      chooser.dataset.match = matchKey;
      document.dispatchEvent(new CustomEvent("gbof:dough-match", { detail: { matchKey } }));
      questions.forEach((question) => { question.hidden = true; });
      result.hidden = false;
      const stickyCta = getStickyCta();
      stickyCta?.classList.add("is-suppressed");
      stickyCta?.setAttribute("aria-hidden", "true");
      setProgress(2);
      result.focus({ preventScroll: false });
    };

    chooser.classList.add("is-enhanced");
    questions.forEach((question, index) => { question.hidden = index !== 0; });
    result.hidden = true;
    setProgress(1);

    chooser.querySelectorAll("[data-gbof-choice]").forEach((button) => {
      button.addEventListener("click", () => {
        const group = button.closest("[data-gbof-chooser-question]");
        if (!group) return;
        setSelected(group, button);
        if (button.dataset.gbofQuestion === "preference") {
          preference = button.dataset.gbofChoice || "";
          showQuestion(1);
          window.setTimeout(() => questions[1].querySelector("[data-gbof-choice]")?.focus({ preventScroll: true }), 0);
          return;
        }
        experience = button.dataset.gbofChoice || "";
        renderResult();
      });
    });

    restart.addEventListener("click", () => {
      preference = "";
      experience = "";
      chooser.querySelectorAll("[data-gbof-choice]").forEach((button) => {
        button.setAttribute("aria-pressed", "false");
        button.classList.remove("is-selected");
      });
      showQuestion(0);
      questions[0].querySelector("[data-gbof-choice]")?.focus({ preventScroll: false });
    });
  }

  document.querySelectorAll(selector).forEach(initialise);
})();
